<div class="wf-manage" *ngIf="!showTYpage">
    <div class="wf-header">
        <div class="row sm-logo">
            <a href="https://www.worknigeria.com"><img src="../assets/images/logo.webp" /></a>
        </div>
        <div class="ten-percent-off row">
            <div class="col-lg-1 col-0"></div>
            <div class="col-lg-5">
                <h1>Struggling to Find the Right Talent or Manage Your Workforce?</h1>
                <p>From fast recruitment to streamlined workforce management, we've got you covered.</p>
                <h4>Get 10% off your first recruitment!</h4>
                <button (click)="scrollToForm()">Claim Offer!</button>
            </div>
            <div class="col-lg-5">
                <img src="../../../assets/images/person-struggle-to-work.webp" />
            </div>
            <div class="col-lg-1 col-0"></div>
        </div>
    </div>
    <!-- Build Workforce Steps -->
    <div class="build-workforce">
        <h2>How We Help You Build a Winning Workforce</h2>
        <hr class="green-hr" />
        <div class="card-container">
            <div class="card" *ngFor="let wf of build_wf">
                <img [src]="wf.photo" />
                <h3>{{ wf.title }}</h3>
                <p>{{ wf.para }}</p>
            </div>
        </div>
        <div class="text-center mt-5">
            <button (click)="scrollToForm()">Get Offer</button>
        </div>
    </div>
    <!-- Reliable Outsourcing -->
    <div class="reliable-outsource">
        <h2>Our Reliable Outsourcing Solutions</h2>
        <div class="text-center">
            <hr class="blue-hr" />
        </div>
        <p class="os-para">Managing payroll, compliance, and employee benefits can be overwhelming. Let us handle
            these critical tasks with our outsourcing solutions, so you can focus on growing your business.</p>
        <div class="card-container">
            <div class="card" *ngFor="let os of reliable_os">
                <img [src]="os.photo" />
                <h3>{{ os.title }}</h3>
                <p>{{ os.para }}</p>
            </div>
        </div>
        <div class="text-center mt-5">
            <button (click)="scrollToForm()">Get Offer</button>
        </div>
    </div>
    <!-- Why WorkNigeria Section -->
    <div class="why-wn">
        <h2>Why WorkNigeria?</h2>
        <hr class="green-hr" />
        <div class="card-container">
            <div class="row">
                <ng-container *ngFor="let wn of why_wn; let i = index">
                    <div class="card" *ngIf="i < 3">
                        <img [src]="wn.photo" />
                        <h3>{{ wn.title }}</h3>
                        <p>{{ wn.para }}</p>
                    </div>
                </ng-container>
            </div>
            <div class="row r2">
                <ng-container *ngFor="let wn of why_wn; let i = index" class="justify-content-center">
                    <div class="card" *ngIf="i >= 3">
                        <img [src]="wn.photo" />
                        <h3>{{ wn.title }}</h3>
                        <p>{{ wn.para }}</p>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
    <!-- What Our Clients Say -->
    <div class="clients-say">
        <h2>What Our Clients Say</h2>
        <hr class="green-hr" />
        <div class="card-container">
            <div class="card" *ngFor="let saying of client_words">
                <div class="stars">
                    <mat-icon *ngFor="let star of stars; let i = index">
                        star
                    </mat-icon>
                </div>
                <h3>{{ saying.quote }}</h3>
                <p class="f_name">{{ saying.f_name }}</p>
                <p class="company">{{ saying.company }}</p>
            </div>
        </div>
    </div>
    <!-- Trusted by Section -->
    <div class="trusted-by-section">
        <h2>Trusted by leading Employers in Nigeria:</h2>
        <div class="ticker-outer-container">
            <div class="ticker-inner-container">
                <div class="ticker-container">
                    <div *ngFor="let logo of logos" class="ticker-item">
                        <img [src]="logo" class="ticker-img" alt="Logo" />
                    </div>
                    <div *ngFor="let logo of logos" class="ticker-item">
                        <img [src]="logo" class="ticker-img" alt="Logo" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Simplify Workforce -->
    <div class="simple-wf">
        <h2>Ready to Simplify Your Workforce Management?</h2>
        <hr class="blue-hr" />
        <p class="para-1">Let us handle recruitment and workforce outsourcing while you focus on what matters — your
            business growth.</p>
        <p class="para-2">Get 10% off your first recruitment today and start building a winning team!</p>
        <p class="para-3">Fill out the form below, and we'll contact you right away to discuss how we can help.</p>
        <form [formGroup]="userDetailsForm" class="simple-form" id="simpleForm">
            <!-- Input Field For Full Name -->
            <label class="input-label"><img src="../../../assets/images/person-icon.webp" /> Name</label>
            <div class="input-container">
                <input type="text" placeholder="Your name" class="form-control" formControlName="fullName">
            </div>
            <div *ngIf="f['fullName'].touched && f['fullName'].invalid" class="invaild-div">
                <span class="text-left text-danger pb-1" *ngIf="f['fullName'].errors?.['required']">
                    Name is required
                </span>
                <span class="text-left text-danger pb-1" *ngIf="f['fullName'].errors?.['pattern']">
                    Please enter a valid name.
                </span>
            </div>
            <!-- Input Field For Email -->
            <label class="input-label"><img src="../../../assets/images/email-icon-2.webp" /> Email</label>
            <div class="input-container">
                <input type="email" placeholder="example@company.com" class="form-control" formControlName="email">
            </div>
            <div *ngIf="f['email'].touched && f['email'].invalid" class="invaild-div">
                <span class="text-left text-danger pb-1" *ngIf="f['email'].errors?.['required']">Email is required.
                </span>
                <span class="text-left text-danger pb-1" *ngIf="f['email'].errors?.['pattern']">
                    Please enter a valid email.
                </span>
            </div>
            <!-- Input Field For Phone Number -->
            <label class="input-label"><img src="../../../assets/images/phone-icon.webp" /> Phone Number</label>
            <div class="input-container">
                <input type="text" placeholder="xxxxxxxxxxx" class="form-control" formControlName="phoneNumber">
            </div>
            <div *ngIf="f['phoneNumber'].touched && f['phoneNumber'].invalid" class="invaild-div">
                <span class="text-left text-danger pb-1" *ngIf="f['phoneNumber'].errors?.['required']">Phone Number is
                    required.
                </span>
                <span class="text-left text-danger pb-1" *ngIf="f['phoneNumber'].errors?.['pattern']">
                    Please enter a valid Phone Number.
                </span>
            </div>
            <button (click)="submitForm()">Submit</button>
            <p class="para-4">By submitting this form, you agree to be contacted by WorkNigeria using the contact
                details you provided. We value your privacy — you can view our <a href="/privacy-policy">Privacy
                    Policy</a> here.</p>
        </form>
    </div>
    <!-- Footer Section -->
    <div class="footer">
        <div class="row">
            <div class="col-0 col-lg-1"></div>
            <div class="col-lg-4 col-12">
                <h4 class="para-wn">Work<span>Nigeria</span></h4>
                <p class="para-desc">Connecting the right talent with the right opportunities to build stronger teams
                    across Nigeria.</p>
            </div>
            <div class="col-lg-3 col-0"></div>
            <div class="col-lg-4 col-0">
            </div>
        </div>
        <hr class="line-hr" />
        <h6>© 2025 WorkNigeria. All rights reserved.</h6>
    </div>
</div>